import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-teachers.tsx
var LazyCourseTeachers = lazy(() => import("./course-teachers-IIX5KNsu.js").then((n) => n.n).then((module) => ({ default: module.CourseTeachers })));
function CourseTeachers({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-teachers" }),
		children: /* @__PURE__ */ jsx(LazyCourseTeachers, { ...props })
	});
}
function CourseTeachersContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-teachers" }),
		children: /* @__PURE__ */ jsx(LazyCourseTeachers, { ...props })
	});
}
var useCourseTeachersContent = () => {
	return useMemo(() => ({ courseTeachers: { component: CourseTeachersContent } }), []);
};
//#endregion
export { CourseTeachers, useCourseTeachersContent };
